import AuthManager from "Common/AuthManager";
import ServiceWrapper from "Services/ServiceWrapper";
import AppSettings from "Settings/AppSettings";

export async function checkJobStatus(jobid: string) {
    if (!jobid) return Promise.reject(new Error("Invalid jobid"));

    const fetchStatus = () => ServiceWrapper.doGet(
        AppSettings.GMS_BACKEND_API_URL + "job/status/" + jobid,
        null,
        null,
        AuthManager.getGmsToken()
    );

    let result = await fetchStatus();

    while (!result.errorfound && !result.data.error && result.data.processing && !result.data.data) {
        await new Promise(resolve => setTimeout(resolve, 2000));
        result = await fetchStatus();
    }

    if (result.errorfound || result.data.error)
        return Promise.reject(new Error(result.data.status ?? "Job fetch failed"));

    return result.data;
}
